export default __webpack_public_path__ + "static/Nerd-73bfd105f87fc82e0394635687b8d0d2.png";